<template>
    <main>
      <div class="container-fluid px-0">
        <div class="row">
          <div class="col-12">
            <div class="custom_page_header">
                <h2>{{$t('message.sintplace')}}</h2>
                <p class="lead customp">{{$t('message.systemicprods')}}</p>
            </div>
          </div>
        </div>

        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-card>
              <b-skeleton animation="fade" width="85%"></b-skeleton>
              <b-skeleton animation="fade" width="55%"></b-skeleton>
              <b-skeleton animation="fade" width="70%"></b-skeleton>
            </b-card>
          </template>
        <div class="row justify-content-center pt-2" v-if="!error_loading">
          <div class="col-12">   
            <div no-body>
              <b-tabs pills card fill>
                <b-tab title="Safetravel.today" @click="sftAtivate" active>
                  <div class="row">
                    <div class="col-12">
                      <template>
                        <!-- buttons outside accordion -->
                        <div class="d-flex mb-2 flex-wrap position-relative">
                          <b-button v-for="(p, i) in productsSompo" :key="i"
                                    v-b-toggle="'accordion-' + p"
                                    :ref="i === 0 ? 'firstSompoBtn' : null"
                                    variant="success"
                                    class="m-1 productsTabBtn"
                                    @click="removeSimulatedClick">
                            {{ products[p] }}
                            <!-- badges -->
                            <font-awesome-icon :icon="['fas', 'circle-chevron-down']" :id="'popover-target-' + i"/>
                            <b-popover :target="'popover-target-' + i" triggers="hover" placement="top">
                              <template #title>Product Features</template>
                              <!-- Badges inside Popover -->
                              <div>
                                <b-badge class="small-badge" variant="secondary">API Integration available</b-badge>
                                <b-badge class="small-badge" variant="success">Recommended / Primary</b-badge>
                                <b-badge class="small-badge" variant="dark">Higher Commission</b-badge>
                              </div>
                            </b-popover>
                            <!-- product based badges -->
                            <b-badge class="small-badge ml-half" variant="warning" v-if="bestValueProducts.includes(p)">Best Value</b-badge>
                            <b-badge class="small-badge ml-half" variant="info" v-if="mostPopularProducts.includes(p)">Most Popular</b-badge>
                            <b-badge class="small-badge ml-half" variant="danger" v-if="fullProtectionProducts.includes(p)">Full Protection</b-badge>
                            
                          </b-button>
                        </div>
                        <div class="accordion" role="tablist">
                          <!-- Dynamic Sompo products -->
                          <b-card no-body class="mb-0" v-for="(p,i) in productsSompo" :key="i">
                            <main>
                              <b-collapse :id="'accordion-'+p" visible accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                  <!-- best for -->
                                  <b-card-text>
                                    <h4 class="text-center mb-1">Best for</h4>
                                    <!-- study -->
                                    <b-list-group class="listgroupsdesc_best_value" v-if="['product-longstay-301'].includes(p)">
                                      <b-list-group-item>
                                        - For Erasmus, Erasmus+ and international students
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - Longstay study visits
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- study extended-->
                                    <b-list-group class="listgroupsdesc_most_popular" v-if="['product-longstay-302'].includes(p)">
                                      <b-list-group-item>
                                        - For Erasmus, Erasmus+ and international students
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - Longstay study visits
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- Basic -->
                                    <b-list-group class="listgroupsdesc_best_value" v-if="['product-single-300', 'product-annual-301', 'product-single-307', 'product-annual-303'].includes(p)">
                                      <b-list-group-item>
                                        - Holidaymakers on budget leisure trips
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - First-time travellers
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - Individuals needing visa-compliant essentials
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- Extended -->
                                    <b-list-group class="listgroupsdesc_most_popular" v-if="['product-single-301', 'product-single-302', 'product-annual-302', 'product-annual-304'].includes(p)">
                                      <b-list-group-item>
                                        - Families and couples on multi-city holidays
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - Travellers with mid-value equipment/luggage
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - Users looking for stronger protection
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- business extended-->
                                    <b-list-group class="listgroupsdesc_most_popular" v-if="['product-single-305'].includes(p)">
                                      <b-list-group-item>
                                        - Business travellers, executives and travellers with full protection expectations
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- business basic-->
                                    <b-list-group class="listgroupsdesc_best_value" v-if="[ 'product-single-306', 'product-annual-305'].includes(p)">
                                      <b-list-group-item>
                                        - Business travellers, executives and travellers with full protection expectations
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- Luxury -->
                                    <b-list-group class="listgroupsdesc_full_protection" v-if="fullProtectionProducts.includes(p)">
                                      <b-list-group-item>
                                        - High-value trips (luxury cruises, global conferences)
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        - Travellers with full protection expectations
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                  </b-card-text>
                                  <!-- popular add-ons -->
                                  <b-card-text>
                                    <h4 class="text-center mb-1">Popular Add-ons</h4>
                                    <!-- Basic -->
                                    <b-list-group class="listgroupsdesc_best_value" v-if="bestValueProducts.includes(p)">
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          checked
                                          disabled
                                        >
                                        Study & Erasmus+ Extension
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                        disabled
                                        >
                                        Winter Sports
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                        disabled
                                        >
                                        Cruise (Corresponds to Travel Agent Leisure Product)
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                        disabled
                                        >
                                        Business
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- Extended -->
                                    <b-list-group class="listgroupsdesc_most_popular" v-if="mostPopularProducts.includes(p)">
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          checked
                                          disabled
                                        >
                                        Study & Erasmus+ Extension
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          disabled
                                        >
                                        Winter Sports
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                        disabled
                                        >
                                        Cruise (Corresponds to Travel Agent Leisure Product)
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                        disabled
                                        >
                                        Business
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                    <!-- Luxury -->
                                    <b-list-group class="listgroupsdesc_full_protection" v-if="fullProtectionProducts.includes(p)">
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          checked
                                          disabled
                                        >
                                        Study & Erasmus+ Extension
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          disabled
                                        >
                                        Winter Sports
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          disabled
                                        >
                                        Cruise (Corresponds to Travel Agent Leisure Product)
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <b-form-checkbox
                                          v-model="isChecked"
                                          disabled
                                        >
                                        Business
                                        </b-form-checkbox>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                  </b-card-text>
                                  <b-card-text>
                                    <h4 class="text-center mb-1">Documents</h4>
                                    <b-list-group class="listgroupsdesc">
                                      <b-list-group-item>
                                        <div class="flexDiv">
                                          <span class="font-weight-bold">TOB</span>
                                          <div v-if="product_documents[p].tob_link">
                                            <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-success">{{product_documents[p].tob_title}}</a>
                                            <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                          </div>
                                        </div>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <div class="flexDiv">
                                          <span class="font-weight-bold">IPID</span>
                                          <div v-if="product_documents[p].ipid_link">
                                            <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-success">{{product_documents[p].ipid_title}}</a>
                                            <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                          </div>
                                        </div>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <div class="flexDiv">
                                          <span class="font-weight-bold">PWO</span>
                                          <div v-if="product_documents[p].pwo_link">
                                            <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-success">{{product_documents[p].pwo_title}}</a>
                                            <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                          </div>
                                        </div>
                                      </b-list-group-item>
                                      <!-- longstay-302 -->
                                      <b-list-group-item v-if="p==='product-longstay-302'">
                                        <div class="flexDiv">
                                          <span class="font-weight-bold">PWO Addition</span>
                                            <div v-if="product_documents[p].pwo_link_addition">
                                                <a target="_blank" :href="product_documents[p].pwo_link_addition" class="btn btn-sm btn-outline-success">Policy Wording Addition</a>
                                                <a target="_blank" :href="product_documents[p].pwo_link_addition" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                            </div>
                                        </div>
                                      </b-list-group-item>
                                      <b-list-group-item>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-list-group-item>
                                    </b-list-group>
                                  </b-card-text>
                                  <b-card-text>
                                    <h4 class="text-center mb-1 mt-2">Coverages</h4>
                                      <div v-for="(pr,k) in productsArr" :key="k">
                                          <b-list-group class="mb-2 listgroupsdesc" v-for="pp in pr[productsSompo[i]]" :key="pp.coverage_code">
                                            <b-list-group-item><b-badge variant="primary">Description</b-badge> {{ pp.description_en }}</b-list-group-item>
                                            <b-list-group-item><b-badge variant="primary">Limit</b-badge> {{ pp.coverage_limit }}</b-list-group-item>
                                            <b-list-group-item><b-badge variant="primary">Excess</b-badge> {{ pp.coverage_excess }}</b-list-group-item>
                                          </b-list-group>
                                      </div>
                                  </b-card-text>
                                  <router-link :to="route('quotation')">
                                    <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                  </router-link>
                                </b-card-body>
                              </b-collapse>
                            </main>
                          </b-card>
                        </div>
                      </template>
                    </div>
                  </div>
                </b-tab>
                <!--
                <b-tab title="Alternatives" @click="onOuterTabActivate">
                  <div class="col-12">
                    <b-card no-body>
                      <b-tabs fill>
                        <b-tab title="Battleface" active @click="onTabActivated('battleface')">
                            <div class="row">
                              <div class="col-12">
                                <template>
                                  <div class="d-flex flex-wrap">
                                    <b-button v-for="(p, i) in productsBattleface" :key="i"
                                              v-b-toggle="'accordion-' + p"
                                              :ref="i === 0 ? 'firstBattlefaceBtn' : null"
                                              variant="outline-success"
                                              class="m-1 productsTabBtn"
                                              @click="removeSimulatedClick">
                                      {{ products[p] }}
                                    </b-button>
                                  </div>
                                  <div class="accordion" role="tablist">
                                    <b-card no-body class="mb-0" v-for="(p,i) in productsBattleface" :key="i">
                                      <b-collapse :id="'accordion-'+p" visible accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                          <b-card-text>
                                            <h4 class="text-center mb-1">Documents</h4>
                                            <b-list-group class="listgroupsdesc">
                                              <b-list-group-item>
                                                <div class="flexDiv">
                                                  <span class="font-weight-bold">TOB</span>
                                                  <div v-if="product_documents[p].tob_link">
                                                    <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-success">{{product_documents[p].tob_title}}</a>
                                                    <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                  </div>
                                                </div>
                                              </b-list-group-item>
                                              <b-list-group-item>
                                                <div class="flexDiv">
                                                  <span class="font-weight-bold">IPID</span>
                                                  <div v-if="product_documents[p].ipid_link">
                                                    <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-success">{{product_documents[p].ipid_title}}</a>
                                                    <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                  </div>
                                                </div>
                                              </b-list-group-item>
                                              <b-list-group-item>
                                                <div class="flexDiv">
                                                  <span class="font-weight-bold">PWO</span>
                                                  <div v-if="product_documents[p].pwo_link">
                                                    <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-success">{{product_documents[p].pwo_title}}</a>
                                                    <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                  </div>
                                                </div>
                                              </b-list-group-item>
                                              <b-list-group-item>
                                                <router-link :to="route('quotation')">
                                                  <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                                </router-link>
                                              </b-list-group-item>
                                            </b-list-group>
                                          </b-card-text>
                                          <b-card-text>
                                            <h4 class="text-center mb-1 mt-2">Coverages</h4>
                                              <div v-for="(pr,k) in productsArr" :key="k">
                                                  <b-list-group class="mb-2 listgroupsdesc" v-for="pp in pr[productsBattleface[i]]" :key="pp.coverage_code">
                                                    <b-list-group-item><b-badge variant="primary">Description</b-badge> {{ pp.description_en }}</b-list-group-item>
                                                    <b-list-group-item><b-badge variant="primary">Limit</b-badge> {{ pp.coverage_limit }}</b-list-group-item>
                                                    <b-list-group-item><b-badge variant="primary">Excess</b-badge> {{ pp.coverage_excess }}</b-list-group-item>
                                                  </b-list-group>
                                              </div>
                                          </b-card-text>
                                          <router-link :to="route('quotation')">
                                            <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                          </router-link>
                                        </b-card-body>
                                      </b-collapse>
                                    </b-card>
                                  </div>
                              </template>
                              </div>
                            </div>
                        </b-tab>
                        <b-tab title="Globelink" @click="onTabActivated('globelink')">
                          <div class="row">
                            <div class="col-12">
                              <template>
                                  <div class="d-flex flex-wrap">
                                    <b-button v-for="(p,i) in productsCollinson" :key="i"
                                              v-b-toggle="'accordion-' + p"
                                              :ref="i === 0 ? 'firstCollinsonBtn' : null"
                                              variant="outline-success"
                                              class="m-1 productsTabBtn"
                                              @click="removeSimulatedClick">
                                      {{ products[p] }}
                                    </b-button>
                                  </div>
                                <div class="accordion" role="tablist">
                                  <b-card no-body class="mb-0" v-for="(p,i) in productsCollinson" :key="i">
                                    <b-collapse :id="'accordion-'+p" visible accordion="my-accordion" role="tabpanel">
                                      <b-card-body>
                                        <b-card-text>
                                          <h4 class="text-center mb-1">Documents</h4>
                                          <b-list-group class="listgroupsdesc">
                                            <b-list-group-item>
                                              <div class="flexDiv">
                                                <span class="font-weight-bold">TOB</span>
                                                <div v-if="product_documents[p].tob_link">
                                                  <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-success">{{product_documents[p].tob_title}}</a>
                                                  <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                </div>
                                              </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                              <div class="flexDiv">
                                                <span class="font-weight-bold">IPID</span>
                                                <div v-if="product_documents[p].ipid_link">
                                                  <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-success">{{product_documents[p].ipid_title}}</a>
                                                  <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                </div>
                                              </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                              <div class="flexDiv">
                                                <span class="font-weight-bold">PWO</span>
                                                <div v-if="product_documents[p].pwo_link">
                                                  <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-success">{{product_documents[p].pwo_title}}</a>
                                                  <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                </div>
                                              </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                              <router-link :to="route('quotation')">
                                                <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                              </router-link>
                                            </b-list-group-item>
                                          </b-list-group>
                                        </b-card-text>
                                        <b-card-text>
                                          <h4 class="text-center mb-1 mt-2">Coverages</h4>
                                            <div v-for="(pr,k) in productsArr" :key="k">
                                                <b-list-group class="mb-2 listgroupsdesc" v-for="pp in pr[productsCollinson[i]]" :key="pp.coverage_code">
                                                  <b-list-group-item><b-badge variant="primary">Description</b-badge> {{ pp.description_en }}</b-list-group-item>
                                                  <b-list-group-item><b-badge variant="primary">Limit</b-badge> {{ pp.coverage_limit }}</b-list-group-item>
                                                  <b-list-group-item><b-badge variant="primary">Excess</b-badge> {{ pp.coverage_excess }}</b-list-group-item>
                                                </b-list-group>
                                            </div>
                                        </b-card-text>
                                        <router-link :to="route('quotation')">
                                          <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                        </router-link>
                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </template>
                            </div>
                          </div>
                        </b-tab>
                        <b-tab title="Mondial" @click="onTabActivated('mondial')">
                          <div class="row">
                            <div class="col-12">
                              <template>
                                <div class="d-flex flex-wrap">
                                  <b-button v-for="(p,i) in productsMondial" :key="i"
                                            v-b-toggle="'accordion-' + p"
                                            :ref="i === 0 ? 'firstMondialBtn' : null"
                                            variant="outline-success"
                                            class="m-1 productsTabBtn"
                                            @click="removeSimulatedClick">
                                    {{ products[p] }}
                                  </b-button>
                                </div>
                                <div class="accordion" role="tablist">
                                  <b-card no-body class="mb-0" v-for="(p,i) in productsMondial" :key="i">
                                    <b-collapse :id="'accordion-'+p" visible accordion="my-accordion" role="tabpanel">
                                      <b-card-body>
                                        <b-card-text>
                                          <h4 class="text-center mb-1">Documents</h4>
                                          <b-list-group class="listgroupsdesc">
                                            <b-list-group-item>
                                              <div class="flexDiv">
                                                <span class="font-weight-bold">TOB</span>
                                                <div v-if="product_documents[p].tob_link">
                                                  <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-success">{{product_documents[p].tob_title}}</a>
                                                  <a target="_blank" :href="product_documents[p].tob_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                </div>
                                              </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                              <div class="flexDiv">
                                                <span class="font-weight-bold">IPID</span>
                                                <div v-if="product_documents[p].ipid_link">
                                                  <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-success">{{product_documents[p].ipid_title}}</a>
                                                  <a target="_blank" :href="product_documents[p].ipid_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                </div>
                                              </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                              <div class="flexDiv">
                                                <span class="font-weight-bold">PWO</span>
                                                <div v-if="product_documents[p].pwo_link">
                                                  <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-success">{{product_documents[p].pwo_title}}</a>
                                                  <a target="_blank" :href="product_documents[p].pwo_link" class="btn btn-sm btn-outline-danger ml-2">Download</a>
                                                </div>
                                              </div>
                                            </b-list-group-item>
                                            <b-list-group-item>
                                              <router-link :to="route('quotation')">
                                                <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                              </router-link>
                                            </b-list-group-item>
                                          </b-list-group>
                                        </b-card-text>
                                        <b-card-text>
                                          <h4 class="text-center mb-1 mt-2">Coverages</h4>
                                            <div v-for="(pr,k) in productsArr" :key="k">
                                                <b-list-group class="mb-2 listgroupsdesc" v-for="pp in pr[productsMondial[i]]" :key="pp.coverage_code">
                                                  <b-list-group-item><b-badge variant="primary">Description</b-badge> {{ pp.coverage_code }}</b-list-group-item>
                                                  <b-list-group-item><b-badge variant="primary">Limit</b-badge> {{ pp.coverage_limit }}</b-list-group-item>
                                                  <b-list-group-item><b-badge variant="primary">Excess</b-badge> {{ pp.coverage_excess }}</b-list-group-item>
                                                </b-list-group>
                                            </div>
                                        </b-card-text>
                                      </b-card-body>
                                      <router-link :to="route('quotation')">
                                        <b-button variant="outline-success" size="sm">Get Quote!</b-button>
                                      </router-link>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </template>
                            </div>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </b-card>
                  </div>
                </b-tab>
                -->
              </b-tabs>
            </div>
          </div>
        </div>
        <ErrorAlert 
          v-else
          heading="Error loading products"
          message="We couldn't load the products at this time. This could be due to a temporary issue with our server or your internet connection."
        />
      </b-skeleton-wrapper>
    </div>
  </main>
</template>

<script>
/* eslint-disable global-require */
// import Locale from '../components/Locale.vue'
import {
  BListGroup, BListGroupItem, BButton, BTabs, BTab, BCard, BCardBody, BCardText, BCollapse, VBToggle, BBadge, BSkeleton, BSkeletonWrapper, BFormCheckbox, BPopover
} from 'bootstrap-vue'
import ErrorAlert from '../pages/components/ErrorAlert.vue';
import { products, product_documents, agentRoutesMixin } from '@/products';

export default {
  mixins: [agentRoutesMixin],
  name: 'Products',
  components: {
    ErrorAlert,
    BListGroup,
    BListGroupItem,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardBody,
    BCardText,
    BCollapse,
    BBadge,
    BSkeleton,
    BSkeletonWrapper,
    BFormCheckbox,
    BPopover,
    // Locale
  },
  metaInfo: {
    title: 'Products | Safetravel.today - Making Travel Insurance Easy',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { 
        name: 'description', 
        content: 'Discover Safetravel.today travel insurance plans with detailed coverage options. Compare benefits and choose the best protection for your trip.' 
      },
      { 
        name: 'keywords', 
        content: 'travel insurance plans, travel coverage, compare travel insurance, trip protection, Safetravel.today' 
      },
      { property: 'og:title', content: 'Safetravel.today - Travel Insurance Coverage Options' },
      { property: 'og:description', content: 'Explore detailed travel insurance coverage, compare plans, and secure your trip online with Safetravel.today.' },
      { property: 'og:image', content: 'https://safetravel.today/images/products.png' },
      { property: 'og:type', content: 'website' },
      { name: 'robots', content: 'index, follow' },
    ],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Safetravel.today',
          url: 'https://safetravel.today',
          logo: 'https://safetravel.today/logo.png',
          sameAs: [
            'https://www.facebook.com/safetraveltoday',
            'https://www.linkedin.com/company/safe-travel',
            'https://x.com/safetraveltoday'
          ],
          description: 'Safetravel.today is a travel insurance company offering secure, flexible, and affordable coverage for safe journeys worldwide.'
        },
      },
    ],
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      error_loading: false,
      isChecked: true,
      products,
      product_documents,
      productsArr: [],
      loading:true,
      productsCollinson: ['product-single-900','product-single-901','product-single-902','product-single-903','product-single-904','product-single-908','product-single-909','product-annual-901','product-annual-902','product-longstay-901','product-longstay-902'],
      productsSompo: ['product-single-300','product-single-301','product-single-302','product-single-303','product-single-304','product-single-305','product-single-306','product-single-307','product-annual-301','product-annual-302','product-longstay-301', 'product-longstay-302','product-annual-303','product-annual-304', 'product-annual-305'],
      productsMondial: ['product-single-6400','product-single-6403','product-single-6535','product-single-6418','product-single-6419','product-single-6421','product-single-6440','product-single-6499','product-single-6520','product-single-6583'],
      productsBattleface: ['product-single-401','product-single-402','product-single-403','product-single-404','product-single-405','product-single-406','product-single-407','product-single-408','product-single-409','product-single-410']
    }
  },
  methods: {
      async getCoverage(products,pos) {
        const urls= {
          c: 'https://api-quote.safetravel.today/v2/app/product_coverages',
          b: 'https://api-quote.safetravel.today/v2/app/product_coveragesb'
        };
        const num = products[0].replace(/^\D+/g, '');
        const url = (num[0] == 4) ? urls.b : urls.c
        const data = {
          token:"1dbaa403b94ccdd1991c3afd511858a5",
          products
        }
        try {
          await fetch(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to get product coverages: HTTP ${response.status}`);
            return response.json();
          })
          .then(res=> {
            if (res) {
              this.productsArr.push(res)
              if (pos==='last') {
                this.loading=false;
              }
            }
          })
        } catch (error) {
          console.error('Error fetching product coverages:', error);
          this.error_loading = true;
          this.loading = false;
        }
      },
    onOuterTabActivate() {
      this.onTabActivated('battleface');
    },
    sftAtivate() {
      this.onTabActivated('sompo');
    },
    onTabActivated(tab) {
      const refMap = {
        sompo: 'firstSompoBtn',
        battleface: 'firstBattlefaceBtn',
        globelink: 'firstCollinsonBtn',
        mondial: 'firstMondialBtn'
      };
      const refName = refMap[tab];
      this.$nextTick(() => {
        const btnArr = this.$refs[refName];
        const btn = Array.isArray(btnArr) ? btnArr[0] : btnArr;
        if (btn) {
          btn.click()
          // Apply conditional class
          if (tab === 'sompo') {
            btn.classList.add('simulated-active_sompo');
          } else {
            btn.classList.add('simulated-active');
          }
        }
      });
    },
    removeSimulatedClick() {
      // Remove 'simulated-active' from all buttons
      const buttons = document.querySelectorAll('.productsTabBtn');
      buttons.forEach(button => {
        button.classList.remove('simulated-active', 'simulated-active_sompo');
      });
    }
  },
  computed: {
    bestValueProducts() {
      return ['product-single-300', 'product-single-306', 'product-annual-301', 'product-longstay-301', 'product-single-307', 'product-annual-305'];
    },
    mostPopularProducts() {
      return ['product-single-301', 'product-single-302', 'product-single-305', 'product-annual-302', 'product-longstay-302',  'product-annual-303', 'product-annual-304'];
    },
    fullProtectionProducts() {
      return ['product-single-303','product-single-304'];
    }
  },
  async created(){
    await this.getCoverage(this.productsCollinson,null)
    await this.getCoverage(this.productsSompo,null)
    await this.getCoverage(this.productsMondial,null)
    await this.getCoverage(this.productsBattleface,'last')
  },
  mounted() {
  for (let key in this.products) {
    this.products[key] = this.products[key].replace('AMT', 'Annual Multi-Trip');
  }
  }
}
</script>

<style lang="scss" scoped>
  .badge {
    color: #fcfcfc;
  }
  .listgroupsdesc {
    box-shadow: 0px 0px 6px 1px var(--accent3-color);
  }
  .listgroupsdesc_best_value {
    box-shadow: 0px 0px 6px 1px #ff9f43;
  }
  .listgroupsdesc_most_popular {
    box-shadow: 0px 0px 6px 1px #00cfe8;
  }
  .listgroupsdesc_full_protection {
    box-shadow: 0px 0px 6px 1px var(--danger-color);
  }
  .flexDiv {
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
  }
  .flexDiv > div {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: center;
  }
  h4 {
    color:var(--accent1-color);
  }
  p:not(.customp),span,li {
    color:var(--foreground-color);
  }
  .small-badge {
    font-size: 0.75rem;
    padding: 0.2em 0.4em;
  }
  .simulated-active_sompo {
    background-color: var(--accent3-color) !important;
  }
  .simulated-active {
    background-color: var(--successlight-color) !important;
  }
  .ml-half {
    margin-left:4px;
  }
  .nav-pills .nav-item:nth-child(2) .nav-link.active {
    background-color: transparent !important;
    color: var(--accent1-color) !important;
  }
</style>
